import {Moarify} from '@programming/moarify'

export function initContactsCollections() {

  new Moarify({
    perPage: 15, 
    totalItems: $('#contacts-collections-list').attr('data-total-items'),
    infiniteScroll: true,
    appendTo: $('#contacts-collections-list'),
  });

}
